<template>
  <div
    class="d-account-dropdown"
    :class="{'has-account-details': showAccoutDetails}"
  >
    <div class="dropdown is-hoverable is-right">
      <div class="dropdown-trigger">
        <button
          class="avatar"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
        >
          <img
            :src="$laravel.user.avatar_url"
            alt="Avatar"
            class="is-avatar"
          >
          <div
            v-if="showAccoutDetails"
            class="has-text-left"
          >
            <p class="has-text-weight-medium">
              {{ $laravel.user.name }}
            </p>
            <p class="has-text-grey">
              {{ $laravel.user.email }}
            </p>
          </div>
        </button>
      </div>
      <div
        id="dropdown-menu"
        class="dropdown-menu"
        role="menu"
      >
        <div class="dropdown-content">
          <a
            href="/"
            class="dropdown-item"
          >
            <span class="icon">
              <i class="mdi mdi-home mdi-18px" />
            </span>
            <span>{{ $t('home') }}</span>
          </a>
          <router-link
            to="/account"
            class="dropdown-item"
          >
            <span class="icon">
              <i class="mdi mdi-account-circle mdi-18px" />
            </span>
            <span>{{ $t('account') }}</span>
          </router-link>
          <hr>
          <a
            href="#"
            class="dropdown-item"
            @click.prevent="$logout()"
          >
            <span class="icon">
              <i class="mdi mdi-logout mdi-18px" />
            </span>
            <span>
              {{ $t('logout') }}
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showAccoutDetails: {
      default: true,
      type: Boolean
    }
  }
};
</script>
